import { MenteeTrackOption } from './MenteePortalService';

const MAX = 3;

type Props = {
    tracks: MenteeTrackOption[];
    selected: number[];
    readOnly: boolean;
    onChange: (next: number[]) => void;
};

const MenteeRegistrationTracks = ({ tracks, selected, readOnly, onChange }: Props) => {
    const atMax = selected.length >= MAX;

    const toggle = (id: number) => {
        if (readOnly) return;
        if (selected.includes(id)) {
            onChange(selected.filter((t) => t !== id));
            return;
        }
        if (atMax) return;
        onChange([...selected, id]);
    };

    return (
        <section className="mreg-card mreg-card-tracks" aria-labelledby="mreg-tracks-title">
            <div className="mreg-tracks-head">
                <h2 id="mreg-tracks-title" className="mreg-card-title">
                    Career Track Interests
                </h2>
                <span className="mreg-tracks-badge" aria-live="polite">
                    {selected.length} / {MAX} selected
                </span>
            </div>
            <p className="mreg-card-sub">
                Select <strong>up to {MAX} tracks</strong> you want mentorship in. These are used to find your
                best-fit mentor.
            </p>
            {tracks.length === 0 ? (
                <p className="mdash-empty">No tracks configured for your cohort yet.</p>
            ) : (
                <ul className="mreg-track-grid">
                    {tracks.map((track) => {
                        const checked = selected.includes(track.id);
                        const blocked = !checked && atMax;
                        return (
                            <li key={track.id}>
                                <button
                                    type="button"
                                    className={`mreg-track-card${checked ? ' is-selected' : ''}${
                                        blocked || readOnly ? ' is-disabled' : ''
                                    }`}
                                    disabled={readOnly || blocked}
                                    aria-pressed={checked}
                                    onClick={() => toggle(track.id)}
                                >
                                    <span className="mreg-track-name">{track.name || `Track ${track.id}`}</span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            )}
            {atMax && !readOnly ? (
                <p className="mreg-track-warning" role="status">
                    Maximum {MAX} tracks allowed. Deselect one before choosing another.
                </p>
            ) : null}
        </section>
    );
};

export default MenteeRegistrationTracks;
